import { render, staticRenderFns } from "./workspace.vue?vue&type=template&id=4c3725ce&scoped=true&"
import script from "./workspace.vue?vue&type=script&lang=js&"
export * from "./workspace.vue?vue&type=script&lang=js&"
import style0 from "./workspace.vue?vue&type=style&index=0&id=4c3725ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3725ce",
  null
  
)

export default component.exports